// Reviews extension (admin side): the product dialog's User Feedback tab — what
// buyers said about the product: its stars, their written reviews and why goods
// came back (AdminShared/feedback). The API's `reviews` extension keeps the
// rating counts it reads. A review may be answered or its words removed here.
import React from "react"
import { ChatBubbleLeftRightIcon } from "@heroicons/react/24/outline"
import ProductFeedback from "../../../AdminShared/feedback/ProductFeedback"
import useProductEditorTexts from "aldoo-ra/CMSModels/StoreProduct/useProductEditorTexts"
import { CatalogEditorProvider, catalogSection, catalogVisible, useCatalogVisibilityContext } from "../shared/catalog-editor"

function UserFeedbackTab({ pid, editor }) {
  const id = pid || editor?.product?.pid
  const t = useProductEditorTexts()
  if (!id) return <div className="text-sm italic text-admin_text_secondary">{t`Save the product first: its feedback comes from buyers.`}</div>
  return (
    <div className="flex flex-col gap-2 max-w-[900px]">
      <h2 className="m-0 text-xl font-semibold">{t`User Feedback`}</h2>
      <p className="m-0 mb-2 text-sm text-admin_text_secondary">{t`What buyers said about this product: their ratings, their written reviews and why they sent it back.`}</p>
      <ProductFeedback pid={id} />
    </div>
  )
}

export const StoreProductExtension = {
  id: "reviews",
  label: "User Feedback",
  description: "Ratings, written reviews and return reasons of the product",
  section: {
    component: catalogSection(UserFeedbackTab),
    label: "User Feedback",
    icon: ChatBubbleLeftRightIcon,
    order: 1450,
    // buyers can only give feedback on a product that is on sale: none before it is approved
    visible: (context) => !!context?.published && catalogVisible("reviews")(context),
  },
  provider: CatalogEditorProvider,
  visibilityContext: useCatalogVisibilityContext,
}
